// dmaActions.js
// dmaActions.js
export const SET_SELECTED_DMAS = "SET_SELECTED_DMAS";
export const CLEAR_SELECTED_DMAS = "CLEAR_SELECTED_DMAS";

export const setSelectedDMAs = (dmas) => ({
  type: SET_SELECTED_DMAS,
  payload: dmas,
});

export const clearSelectedDMAs = () => ({
  type: CLEAR_SELECTED_DMAS,
});
